import getLocalString from "constants/Localization";
import { useGetReportContactDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportContactDetails = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportContactDetailsMutation();
  const [getReportContactDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportContactDetails",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportContactDetails, { ...context, data }] as const;
};

export default useGetReportContactDetails;
